
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/batch-group/[slug]/[batchGroupUID]",
      function () {
        return require("private-next-pages/batch-group/[slug]/[batchGroupUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/batch-group/[slug]/[batchGroupUID]"])
      });
    }
  